import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";
import { BusinessCentralSection } from "components/BusinessCentral/BusinessCentralSection";

export const businessCentralSection = (company: server.dto.Company, displayBusinessCentralNumber: boolean): CustomSection => {
  return {
    type: "custom",
    key: "businesscentralsection",
    render: () => <BusinessCentralSection
      businessCentralNumber={company.businessCentralNumber}
      company={company}
    />,
    hidden: !displayBusinessCentralNumber,
  }
}